import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { toast } from "react-toastify";
import { fetchSuccessorSession, SESSION_QUERY_KEY } from "./CheckSessionHook";

export type LoginSuccessorPayload = { email: string; password: string };
export type LoginSuccessorResponse = { status: "success" };

export const useLoginSuccessor = (
  options?: UseMutationOptions<LoginSuccessorResponse, any, LoginSuccessorPayload>
) => {
  return useMutation({
    mutationKey: ["successors", "login"],
    mutationFn: async (payload: LoginSuccessorPayload) => {
      const res = await axiosInstance.post(`/successors/login`, payload);
      return res.data as LoginSuccessorResponse;
    },
    onMutate: (variables) => {
      Toast({
        message: "Logowanie do zakładki Sukcesja…",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "login-successor",
      });
      return options?.onMutate?.(variables);
    },
    onSuccess: async (data, variables, context) => {
      Toast({
        message: "Zalogowano pomyślnie",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "login-successor",
      });

      await queryClient.prefetchQuery({
        queryKey: SESSION_QUERY_KEY,
        queryFn: fetchSuccessorSession,
      });

      options?.onSuccess?.(data, variables, context);
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      const status = error?.status ?? error?.response?.status;

      if (status === 422) {
        Toast({ message: "Nieprawidłowe dane", type: TOAST_TYPES_ENUM.ERROR, id: "login-successor" });
      } else if (status === 403) {
        Toast({ message: "Konto zawieszone", type: TOAST_TYPES_ENUM.ERROR, id: "login-successor" });
      } else if (status === 401) {
        Toast({ message: "Nieautoryzowany dostęp", type: TOAST_TYPES_ENUM.ERROR, id: "login-successor" });
      } else if (status === 500) {
        Toast({ message: "Błąd serwera", type: TOAST_TYPES_ENUM.ERROR, id: "login-successor" });
      } else {
        toast.dismiss("login-successor");
      }

      options?.onError?.(error, variables, context);
    },
  });
};
